import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/tarieven.scss';

const Tarieven = () => {
  const [activeService, setActiveService] = useState('mechanische');
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Tarieven - Fresh Air Care';
  }, []);

  const handleContactClick = () => {
    navigate('/Contact');
  };

  return (
    <div className="tarieven-page">
      {/* ========== HERO ========== */}
      <section className="tarieven-hero">
        <div className="tarieven-container">
          <div className="tarieven-hero-content">
            <h1 className="tarieven-hero-title">
              Transparante <span className="tarieven-accent">prijzen</span>
            </h1>
            <p className="tarieven-hero-description">
              Geen verborgen kosten, geen verrassingen. Bekijk onze vaste prijzen voor alle ventilatie-oplossingen.
            </p>
          </div>
        </div>
      </section>

      {/* ========== SERVICE SELECTOR ========== */}
      <section className="tarieven-service-selector">
        <div className="tarieven-container">
          <div className="tarieven-service-tabs">
            <button 
              className={`tarieven-service-tab ${activeService === 'mechanische' ? 'active' : ''}`}
              onClick={() => setActiveService('mechanische')}
            >
              Mechanische Ventilatie
            </button>
            <button 
              className={`tarieven-service-tab ${activeService === 'wtw' ? 'active' : ''}`}
              onClick={() => setActiveService('wtw')}
            >
              WTW Systemen
            </button>
            <button 
              className={`tarieven-service-tab ${activeService === 'dakventilatie' ? 'active' : ''}`}
              onClick={() => setActiveService('dakventilatie')}
            >
              Dakventilatie
            </button>
          </div>
        </div>
      </section>

      {/* ========== MECHANISCHE VENTILATIE PRICING ========== */}
      {activeService === 'mechanische' && (
        <section key="mechanische" className="tarieven-pricing-section mechanische">
          <div className="tarieven-container">
            <div className="tarieven-pricing-header">
              <h2 className="tarieven-pricing-title">Mechanische Ventilatie</h2>
              <p className="tarieven-pricing-description">
                Professionele installatie en onderhoud van mechanische ventilatiesystemen
              </p>
            </div>

            <div className="tarieven-pricing-grid">
              <div className="tarieven-pricing-card tarieven-pricing-featured">
                <div className="tarieven-pricing-card-header">
                  <h3 className="tarieven-pricing-card-title">Vervangen MV-box</h3>
                  <div className="tarieven-pricing-badge featured">Aanbevolen</div>
                </div>
                <div className="tarieven-pricing-price">
                  <span className="tarieven-price-amount">€475</span>
                  <span className="tarieven-price-period">incl. btw</span>
                </div>
                <div className="tarieven-pricing-features">
                  <div className="tarieven-feature-item">Incl. voorrijkosten</div>
                  <div className="tarieven-feature-item">Incl. kanaalreiniging</div>
                  <div className="tarieven-feature-item">Excl. RF bediening en ventielen</div>
                  <div className="tarieven-feature-item">Nieuwe boxen standaard met vochtsensor</div>
                </div>
                <button onClick={handleContactClick} className="tarieven-pricing-cta">Boek Nu</button>
              </div>

              <div className="tarieven-pricing-card">
                <div className="tarieven-pricing-card-header">
                  <h3 className="tarieven-pricing-card-title">Service</h3>
                  <div className="tarieven-pricing-badge">Uurtarief</div>
                </div>
                <div className="tarieven-pricing-price">
                  <span className="tarieven-price-amount">€145</span>
                  <span className="tarieven-price-period">per uur</span>
                </div>
                <div className="tarieven-pricing-features">
                  <div className="tarieven-feature-item">Incl. btw en voorrijkosten</div>
                  <div className="tarieven-feature-item">Excl. mogelijke onderdelen</div>
                  <div className="tarieven-feature-item">Professioneel advies</div>
                </div>
                <button onClick={handleContactClick} className="tarieven-pricing-cta">Boek Nu</button>
              </div>

              <div className="tarieven-pricing-card">
                <div className="tarieven-pricing-card-header">
                  <h3 className="tarieven-pricing-card-title">Vervangen en reinigen <br/>alles-in-1</h3>
                  <div className="tarieven-pricing-badge">Compleet</div>
                </div>
                <div className="tarieven-pricing-price">
                  <span className="tarieven-price-amount">€575</span>
                  <span className="tarieven-price-period">incl. btw</span>
                </div>
                <div className="tarieven-pricing-features">
                  <div className="tarieven-feature-item">MV box Itho Daalderop met vochtsensor</div>
                  <div className="tarieven-feature-item">Kanalen reinigen</div>
                  <div className="tarieven-feature-item">4 nieuwe ventielen</div>
                  <div className="tarieven-feature-item">Draadloze bediening</div>
                  <div className="tarieven-feature-item">Meetrapport</div>
                  <div className="tarieven-feature-item">Voor & na foto's</div>
                  <div className="tarieven-feature-item">Advies en uitleg</div>
                </div>
                <button onClick={handleContactClick} className="tarieven-pricing-cta">Boek Nu</button>
              </div>
            </div>

            {/* ========== MAINTENANCE CARDS ========== */}
            <div className="tarieven-maintenance-section">
              <div className="tarieven-maintenance-header">
                <h3 className="tarieven-maintenance-title">Reiniging & Onderhoud</h3>
                <p className="tarieven-maintenance-description">
                  Professionele reiniging en onderhoud van uw ventilatiesysteem
                </p>
              </div>

              <div className="tarieven-maintenance-grid">
                <div className="tarieven-pricing-card">
                  <div className="tarieven-pricing-card-header">
                    <h3 className="tarieven-pricing-card-title">Basis Reiniging</h3>
                    <div className="tarieven-pricing-badge">Starter</div>
                  </div>
                  <div className="tarieven-pricing-price">
                    <span className="tarieven-price-amount">€99</span>
                    <span className="tarieven-price-period">eenmalig</span>
                  </div>
                  <div className="tarieven-pricing-features">
                    <div className="tarieven-feature-item">Mechanische ventilatiebox reinigen</div>
                    <div className="tarieven-feature-item">Meetrapport</div>
                    <div className="tarieven-feature-item">Voor & na foto's</div>
                  </div>
                  <button onClick={handleContactClick} className="tarieven-pricing-cta">Boek Nu</button>
                </div>

                <div className="tarieven-pricing-card tarieven-pricing-featured">
                  <div className="tarieven-pricing-card-header">
                    <h3 className="tarieven-pricing-card-title">Kanalen Reinigen</h3>
                    <div className="tarieven-pricing-badge featured">Populair</div>
                  </div>
                  <div className="tarieven-pricing-price">
                    <span className="tarieven-price-amount">€149</span>
                    <span className="tarieven-price-period">eenmalig</span>
                  </div>
                  <div className="tarieven-pricing-features">
                    <div className="tarieven-feature-item">Kanalen reinigen</div>
                    <div className="tarieven-feature-item">Ventielen reinigen</div>
                    <div className="tarieven-feature-item">Meetrapport</div>
                    <div className="tarieven-feature-item">Voor & na foto's</div>
                  </div>
                  <button onClick={handleContactClick} className="tarieven-pricing-cta">Boek Nu</button>
                </div>

                <div className="tarieven-pricing-card">
                  <div className="tarieven-pricing-card-header">
                    <h3 className="tarieven-pricing-card-title">Complete Reiniging</h3>
                    <div className="tarieven-pricing-badge">Premium</div>
                  </div>
                  <div className="tarieven-pricing-price">
                    <span className="tarieven-price-amount">€189</span>
                    <span className="tarieven-price-period">eenmalig</span>
                  </div>
                  <div className="tarieven-pricing-features">
                    <div className="tarieven-feature-item">Mechanische ventilatiebox reinigen</div>
                    <div className="tarieven-feature-item">Kanalen reinigen</div>
                    <div className="tarieven-feature-item">Ventielen reinigen</div>
                    <div className="tarieven-feature-item">Meetrapport</div>
                    <div className="tarieven-feature-item">Voor & na foto's</div>
                  </div>
                  <button onClick={handleContactClick} className="tarieven-pricing-cta">Boek Nu</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* ========== WTW SYSTEMEN PRICING ========== */}
      {activeService === 'wtw' && (
        <section key="wtw" className="tarieven-pricing-section">
          <div className="tarieven-container">
            <div className="tarieven-pricing-header">
              <h2 className="tarieven-pricing-title">WTW Systemen</h2>
              <p className="tarieven-pricing-description">
                Balansventilatie met warmteterugwinning voor optimale energiebesparing
              </p>
            </div>

            <div className="tarieven-pricing-grid">
              <div className="tarieven-pricing-card tarieven-pricing-featured">
                <div className="tarieven-pricing-card-header">
                  <h3 className="tarieven-pricing-card-title">WTW Installatie</h3>
                  <div className="tarieven-pricing-badge featured">Compleet</div>
                </div>
                <div className="tarieven-pricing-price">
                  <span className="tarieven-price-amount">Op Aanvraag</span>
                  <span className="tarieven-price-period">maatwerk</span>
                </div>
                <div className="tarieven-pricing-features">
                  <div className="tarieven-feature-item">WTW vervangen</div>
                  <div className="tarieven-feature-item">Oude unit afvoeren</div>
                  <div className="tarieven-feature-item">Afzuigkanalen reinigen</div>
                  <div className="tarieven-feature-item">Toevoerkanalen reinigen</div>
                  <div className="tarieven-feature-item">Ventielen reinigen</div>
                  <div className="tarieven-feature-item">Meetrapport</div>
                  <div className="tarieven-feature-item">Voor en na foto's</div>
                  <div className="tarieven-feature-item">Advies en uitleg</div>
                </div>
                <button onClick={handleContactClick} className="tarieven-pricing-cta">Offerte</button>
              </div>
            </div>

            {/* ========== MAINTENANCE CARDS ========== */}
            <div className="tarieven-maintenance-section">
              <div className="tarieven-maintenance-header">
                <h3 className="tarieven-maintenance-title">Reiniging & Onderhoud</h3>
                <p className="tarieven-maintenance-description">
                  Professionele reiniging en onderhoud van uw WTW-systeem
                </p>
              </div>

              <div className="tarieven-maintenance-grid">
                <div className="tarieven-pricing-card">
                  <div className="tarieven-pricing-card-header">
                    <h3 className="tarieven-pricing-card-title">Basis Reiniging</h3>
                    <div className="tarieven-pricing-badge">Starter</div>
                  </div>
                  <div className="tarieven-pricing-price">
                    <span className="tarieven-price-amount">€164</span>
                    <span className="tarieven-price-period">eenmalig</span>
                  </div>
                  <div className="tarieven-pricing-features">
                    <div className="tarieven-feature-item">WTW reinigen</div>
                    <div className="tarieven-feature-item">Meetrapport</div>
                    <div className="tarieven-feature-item">Voor & na foto's</div>
                  </div>
                  <button onClick={handleContactClick} className="tarieven-pricing-cta">Boek Nu</button>
                </div>

                <div className="tarieven-pricing-card tarieven-pricing-featured">
                  <div className="tarieven-pricing-card-header">
                    <h3 className="tarieven-pricing-card-title">Kanalen Reinigen</h3>
                    <div className="tarieven-pricing-badge featured">Populair</div>
                  </div>
                  <div className="tarieven-pricing-price">
                    <span className="tarieven-price-amount">€174</span>
                    <span className="tarieven-price-period">eenmalig</span>
                  </div>
                  <div className="tarieven-pricing-features">
                    <div className="tarieven-feature-item">Afzuigkanalen reinigen</div>
                    <div className="tarieven-feature-item">Toevoerkanalen reinigen</div>
                    <div className="tarieven-feature-item">Ventielen reinigen</div>
                    <div className="tarieven-feature-item">Meetrapport</div>
                    <div className="tarieven-feature-item">Voor & na foto's</div>
                  </div>
                  <button onClick={handleContactClick} className="tarieven-pricing-cta">Boek Nu</button>
                </div>

                <div className="tarieven-pricing-card">
                  <div className="tarieven-pricing-card-header">
                    <h3 className="tarieven-pricing-card-title">Complete Reiniging</h3>
                    <div className="tarieven-pricing-badge">Premium</div>
                  </div>
                  <div className="tarieven-pricing-price">
                    <span className="tarieven-price-amount">€274</span>
                    <span className="tarieven-price-period">eenmalig</span>
                  </div>
                  <div className="tarieven-pricing-features">
                    <div className="tarieven-feature-item">WTW reinigen</div>
                    <div className="tarieven-feature-item">Afzuigkanalen reinigen</div>
                    <div className="tarieven-feature-item">Toevoerkanalen reinigen</div>
                    <div className="tarieven-feature-item">Ventielen reinigen</div>
                    <div className="tarieven-feature-item">Meetrapport</div>
                    <div className="tarieven-feature-item">Voor & na foto's</div>
                  </div>
                  <button onClick={handleContactClick} className="tarieven-pricing-cta">Boek Nu</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* ========== DAKVENTILATIE PRICING ========== */}
      {activeService === 'dakventilatie' && (
        <section key="dakventilatie" className="tarieven-pricing-section">
          <div className="tarieven-container">
            <div className="tarieven-pricing-header">
              <h2 className="tarieven-pricing-title">Dakventilatie</h2>
              <p className="tarieven-pricing-description">
                Professionele dakventilatie en kanalen voor optimale vochtbeheersing
              </p>
            </div>

            <div className="tarieven-pricing-grid">
              <div className="tarieven-pricing-card tarieven-pricing-featured">
                <div className="tarieven-pricing-card-header">
                  <h3 className="tarieven-pricing-card-title">Dakventilatie Vervangen</h3>
                  <div className="tarieven-pricing-badge featured">Compleet</div>
                </div>
                <div className="tarieven-pricing-price">
                  <span className="tarieven-price-amount">Op Aanvraag</span>
                  <span className="tarieven-price-period">maatwerk</span>
                </div>
                <div className="tarieven-pricing-features">
                  <div className="tarieven-feature-item">Dakventilator vervangen</div>
                  <div className="tarieven-feature-item">Kanalen reinigen</div>
                  <div className="tarieven-feature-item">Ventielen reinigen</div>
                  <div className="tarieven-feature-item">Meetrapport</div>
                  <div className="tarieven-feature-item">Voor en na foto's</div>
                  <div className="tarieven-feature-item">Uitleg en advies op maat</div>
                </div>
                <button onClick={handleContactClick} className="tarieven-pricing-cta">Offerte</button>
              </div>
            </div>

            {/* ========== MAINTENANCE CARDS ========== */}
            <div className="tarieven-maintenance-section">
              <div className="tarieven-maintenance-header">
                <h3 className="tarieven-maintenance-title">Reiniging & Onderhoud</h3>
                <p className="tarieven-maintenance-description">
                  Professionele reiniging en onderhoud van uw dakventilatiesysteem
                </p>
              </div>

              <div className="tarieven-maintenance-grid">
                <div className="tarieven-pricing-card">
                  <div className="tarieven-pricing-card-header">
                    <h3 className="tarieven-pricing-card-title">Basis Reiniging</h3>
                    <div className="tarieven-pricing-badge">Starter</div>
                  </div>
                  <div className="tarieven-pricing-price">
                    <span className="tarieven-price-amount">Op Aanvraag</span>
                    <span className="tarieven-price-period">maatwerk</span>
                  </div>
                  <div className="tarieven-pricing-features">
                    <div className="tarieven-feature-item">Dakventilator reinigen</div>
                    <div className="tarieven-feature-item">Meetrapport</div>
                    <div className="tarieven-feature-item">Voor & na foto's</div>
                  </div>
                  <button onClick={handleContactClick} className="tarieven-pricing-cta">Offerte</button>
                </div>

                <div className="tarieven-pricing-card tarieven-pricing-featured">
                  <div className="tarieven-pricing-card-header">
                    <h3 className="tarieven-pricing-card-title">Kanalen Reinigen</h3>
                    <div className="tarieven-pricing-badge featured">Populair</div>
                  </div>
                  <div className="tarieven-pricing-price">
                    <span className="tarieven-price-amount">Op Aanvraag</span>
                    <span className="tarieven-price-period">maatwerk</span>
                  </div>
                  <div className="tarieven-pricing-features">
                    <div className="tarieven-feature-item">Kanalen reinigen</div>
                    <div className="tarieven-feature-item">Ventielen reinigen</div>
                    <div className="tarieven-feature-item">Meetrapport</div>
                    <div className="tarieven-feature-item">Voor & na foto's</div>
                  </div>
                  <button onClick={handleContactClick} className="tarieven-pricing-cta">Offerte</button>
                </div>

                <div className="tarieven-pricing-card">
                  <div className="tarieven-pricing-card-header">
                    <h3 className="tarieven-pricing-card-title">Werkzaamheden</h3>
                    <div className="tarieven-pricing-badge">Premium</div>
                  </div>
                  <div className="tarieven-pricing-price">
                    <span className="tarieven-price-amount">€275</span>
                    <span className="tarieven-price-period">eenmalig</span>
                  </div>
                  <div className="tarieven-pricing-features">
                    <div className="tarieven-feature-item">Dakventilator reinigen</div>
                    <div className="tarieven-feature-item">Reinigen ventilatie kanalen</div>
                    <div className="tarieven-feature-item">Reinigen en afstellen ventielen</div>
                    <div className="tarieven-feature-item">Voor en na foto's</div>
                    <div className="tarieven-feature-item">Afstellen systeem</div>
                    <div className="tarieven-feature-item">Uitleg en ventilatieadvies</div>
                  </div>
                  <button onClick={handleContactClick} className="tarieven-pricing-cta">Boek Nu</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* ========== CTA SECTION ========== */}
      <section className="tarieven-cta-section">
        <div className="tarieven-container">
          <div className="tarieven-cta-content">
            <h2 className="tarieven-cta-title">Klaar voor een offerte?</h2>
            <p className="tarieven-cta-description">
              Vraag vandaag nog een gratis inspectie aan en ontdek welke oplossing het beste bij jouw situatie past.
            </p>
            <div className="tarieven-cta-buttons">
              <button onClick={handleContactClick} className="tarieven-cta-primary">Gratis Inspectie</button>
              <a 
                href={activeService === 'mechanische' ? '/Mechanische-ventilatie' : activeService === 'wtw' ? '/WTW-systemen' : '/Dakventilatie'} 
                className="tarieven-cta-secondary" 
                onClick={(e) => {
                  e.preventDefault();
                  const route = activeService === 'mechanische' ? '/Mechanische-ventilatie' : activeService === 'wtw' ? '/WTW-systemen' : '/Dakventilatie';
                  window.location.href = route;
                }}
              >
                Bekijk Services
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Tarieven;